<template>
    <v-container id="enewsletter">
        <v-breadcrumbs class="px-0" :items="items"></v-breadcrumbs>
        <v-row>
            <v-col>
                <span class="text-tcdc-green header bold">E-newsletter</span>
            </v-col>
        </v-row>
        <v-layout>
            <v-flex>
                <div class="mb-3">{{$t('enewsletter.email')}}</div>
                <v-text-field
                        outlined
                        dense
                        color="#34A93E"
                        type="email"
                        v-model="myEmail"
                        :placeholder="$t('enewsletter.youremail')"
                ></v-text-field>
            </v-flex>
        </v-layout>
        <v-layout class="mb-5">
            <v-flex>
                <div class="mb-3">{{$t('enewsletter.interest')}}</div>
                <div style="position: relative;"
                     :class="{ 'd-flex flex-wrap': $vuetify.breakpoint.smAndUp }"
                     :style="{ 'height': $vuetify.breakpoint.xs ? '300px':'auto', 'overflow-y': $vuetify.breakpoint.xs ? 'scroll':'none' }">
                    <v-chip
                            v-for="(chip, i) in allCategories"
                            :key="i"
                            color="#34A93E"
                            class="mb-3 mr-2"
                            :outlined="!myCate.includes(chip[`name_${lang}`])"
                            :text-color="myCate.includes(chip[`name_${lang}`]) ? '#fff':'#000'"
                            :class="{ 'selectedCate': myCate.includes(chip[`name_${lang}`]) }"
                            @click="addInterested(chip[`name_${lang}`])"
                    >
                        {{ chip[`name_${lang}`] }}
                    </v-chip>
                </div>
            </v-flex>
        </v-layout>
        <div class="d-flex justify-center">
            <GreenButton :label="$t('enewsletter.subscribe')" @onPress="getSubscribe"></GreenButton>
        </div>
        <AlertModal
                :show="dialog"
                :message="resMessage"
                @onConfirm="dialog = false"
        ></AlertModal>
    </v-container>
</template>

<script>
    import GreenButton from "../../components/buttons/GreenButton";
    import { mapState } from 'vuex';
    import AlertModal from "../../components/modals/AlertModal";

    export default {
        components: {
            GreenButton,
            AlertModal
        },
        async created() {
            this.items[0].text = this.branchName;
            await this.$store.dispatch('Contact/onGetCategoryEnewsletter');
        },
        computed: {
            ...mapState({
                branchName: state => state.Branch.branch_name,
                lang: state => state.Branch.lang,
                allCategories: state => state.Contact.categories
            }),
            branchChanged: function () {
                return this.branchName;
            }
        },
        watch: {
            branchChanged: function() {
                this.items[0].text = this.branchChanged;
            }
        },
        methods: {
          addInterested(item) {
              if (this.myCate.includes(item)) {
                  this.myCate = this.myCate.filter(x => x !== item);
              } else {
                  this.myCate.push(item);
              }
          },
          getSubscribe() {
              if (this.myEmail) {
                  // validate email pattern
                  let regEx = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
                  if (regEx.test(this.myEmail)) {
                      this.$store.dispatch('Contact/onSubscribeEnewsletter', {
                          email: this.myEmail,
                          interested: this.myCate
                      }).then(() => {
                          this.resMessage = this.$t('messageBox.enews-success');
                          this.dialog = true;
                          this.myEmail = "";
                          this.myCate = [];
                      }).catch(() => {
                          this.resMessage = this.$t('messageBox.enews-failed');
                          this.dialog = true;
                      });
                  } else {
                      this.resMessage = this.$t('messageBox.enews-validate');
                      this.dialog = true;
                  }
              } else {
                  this.resMessage = this.$t('messageBox.enews-validate');
                  this.dialog = true;
              }
          }
        },
        data: () => ({
            myEmail: '',
            myCate: [],
            dialog: false,
            resMessage: '',
            items: [
                {
                    text: 'TCDC BANGKOK',
                    href: "/home"
                },
                {
                    text: "TCDC E-Newsletter",
                }
            ]
        })
    };
</script>

<style>
    .selectedCate {
        background: #34A93E !important;
        color: #fff !important;
        border: solid 1px #34A93E;
    }
</style>
